/**
 * Επιλογή καταλόγου που δείχνει σε κατηγορία που ΔΕΝ φαίνεται πια (24/10/2026).
 *
 * Αφορμή: «Καθαρισμός ημέρας» ενώ ο ταμίας είναι μέσα στα «Πιάτα ημέρας» — η κατηγορία κρύβεται
 * (applyDailyDishes: χωρίς σημερινά δεν φαίνεται), αλλά έμενε επιλεγμένη και ο κατάλογος έδειχνε
 * «0 προϊόντα / Δεν βρέθηκαν προϊόντα» ώσπου να πατηθεί άλλη κατηγορία. Το ίδιο όταν ο διαχειριστής
 * κρύψει/απενεργοποιήσει την κατηγορία που βλέπει ο ταμίας.
 *
 *  - 'category': χάθηκε η ίδια η κατηγορία → η αρχική προβολή της οθόνης (καμία επιλογή).
 *  - 'subcategory': χάθηκε μόνο η υποκατηγορία (μετρά μόνο στην προβολή προϊόντων) → η κατηγορία της.
 * null = η επιλογή υπάρχει, ή δεν υπάρχει επιλογή, ή ο κατάλογος δεν έχει φορτώσει ακόμη (άδειος).
 */
import type { Category } from '../types/order';

export type LostCatalogSelection =
  | { kind: 'category' }
  | { kind: 'subcategory'; category: Category };

export function lostCatalogSelection(
  categories: Category[],
  selectedCategory: number | null,
  selectedSubcategory: number | null,
  currentView: 'categories' | 'subcategories' | 'products',
): LostCatalogSelection | null {
  // Ό,τι δείχνει ο κατάλογος ως κουτί κατηγορίας (ίδιο φίλτρο με το ProductCatalog).
  const visible = categories.filter(c => !c.is_system && !c.is_hidden);
  if (visible.length === 0 || selectedCategory == null) return null;
  const category = visible.find(c => c.id === selectedCategory);
  if (!category) return { kind: 'category' };
  if (currentView !== 'products' || selectedSubcategory == null) return null;
  const subs = (category.subcategories || []).filter(s => !s.is_hidden);
  return subs.some(s => s.id === selectedSubcategory) ? null : { kind: 'subcategory', category };
}
